(function () {
  function getCartAddUrl() {
    if (window.routes && window.routes.cartAddUrl) {
      return window.routes.cartAddUrl + '.js';
    }

    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root + 'cart/add.js';
    }

    return '/cart/add.js';
  }

function initLhPetFeaturedProductsSlider() {
  // 页面有多个 section 或脚本被重复加载时，只注册一次
  if (window.LH_PET_FEATURED_PRODUCTS_SLIDER_DELEGATED) return;

  window.LH_PET_FEATURED_PRODUCTS_SLIDER_DELEGATED = true;

  function getScrollAmount(slider) {
    var cards = slider.querySelectorAll(
      '.lh_pet_featured_products__card'
    );

    /*
     * 用前两张卡片的真实位置差计算移动距离。
     * 这个距离已经包含 gap。
     */
    if (cards.length > 1) {
      var firstRect = cards[0].getBoundingClientRect();
      var secondRect = cards[1].getBoundingClientRect();

      var distance = Math.abs(
        secondRect.left - firstRect.left
      );

      if (distance > 1) {
        return distance;
      }
    }

    var card = cards[0];

    if (!card) {
      return slider.clientWidth;
    }

    var sliderStyle = window.getComputedStyle(slider);

    var gap =
      parseFloat(sliderStyle.columnGap) ||
      parseFloat(sliderStyle.gap) ||
      12;

    return card.getBoundingClientRect().width + gap;
  }

  function moveSlider(button) {
    // 只查找当前按钮所属的产品模块
    var section = button.closest(
      '.lh_pet_featured_products'
    );

    if (!section) return;

    var slider = section.querySelector(
      '[data-lh-pet-featured-products-slider]'
    );

    if (!slider) return;

    var direction = button.classList.contains(
      'lh_pet_featured_products__arrow_prev'
    )
      ? -1
      : 1;

    var amount = getScrollAmount(slider);

    var maxScroll = Math.max(
      0,
      slider.scrollWidth - slider.clientWidth
    );

    var currentLeft = slider.scrollLeft;

    var targetLeft = currentLeft + direction * amount;

    targetLeft = Math.max(
      0,
      Math.min(targetLeft, maxScroll)
    );

    console.log('LH product slider move:', {
      direction: direction,
      currentLeft: currentLeft,
      targetLeft: targetLeft,
      amount: amount,
      maxScroll: maxScroll
    });

    if (typeof slider.scrollTo === 'function') {
      try {
        slider.scrollTo({
          left: targetLeft,
          behavior: 'smooth'
        });
      } catch (error) {
        slider.scrollLeft = targetLeft;
      }
    } else {
      slider.scrollLeft = targetLeft;
    }
  }

  /*
   * 使用捕获阶段 true。
   * 即使 Shopify 主题或其他脚本在冒泡阶段阻止 click，
   * 这里仍然可以先接收到点击。
   */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;

      if (!(target instanceof Element)) return;

      var button = target.closest(
        '.lh_pet_featured_products__arrow'
      );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      moveSlider(button);
    },
    true
  );
}

  function initLhPetFeaturedProductsAddToCart() {
    document.querySelectorAll('.lh_pet_featured_products__form').forEach(function (form) {
      if (form.dataset.lhPetAddReady === 'true') return;
      form.dataset.lhPetAddReady = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var button = form.querySelector('[data-action="add-to-cart"]');
        var formData = new FormData(form);
        var quantity = Number(formData.get('quantity') || 1);

        if (button) {
          button.disabled = true;
          button.classList.add('is-loading');
        }

        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        fetch(getCartAddUrl(), {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (error) {
                throw error;
              });
            }

            return response.json();
          })
          .then(function (item) {
            document.documentElement.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: item,
                quantity: quantity,
                button: button
              }
            }));
          })
          .catch(function (error) {
            console.log('LH pet add to cart error:', error);

            document.documentElement.dispatchEvent(new CustomEvent('cart:error', {
              bubbles: true,
              detail: {
                error: error,
                button: button
              }
            }));

            document.dispatchEvent(new CustomEvent('theme:loading:end'));
          })
          .finally(function () {
            if (button) {
              button.disabled = false;
              button.classList.remove('is-loading');
            }
          });
      });
    });
  }

  function initLhPetFeaturedProducts() {
    initLhPetFeaturedProductsSlider();
    initLhPetFeaturedProductsAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLhPetFeaturedProducts);
  } else {
    initLhPetFeaturedProducts();
  }

  document.addEventListener('shopify:section:load', initLhPetFeaturedProducts);
})();
console.log('LH pet video js loaded');
// 视频部分
(function(){
  if(window.LH_PET_VIDEO_READY) return;
  window.LH_PET_VIDEO_READY = true;

  let currentVideo = null;

  function isMobile(){
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function stopOtherVideos(except){
    document.querySelectorAll('.lh_pet_video_carousel__autoplay_video').forEach(video=>{
      if(video !== except){
        video.pause();
      }
    });
  }

  function playVideo(video){
    if(!video) return;

    stopOtherVideos(video);

    if(!video.src){
      const src = video.dataset.videoSrc;
      if(src){
        video.src = src;
        video.load();
      }
    }

    video.play().catch(()=>{});

    currentVideo = video;
  }


  function initAutoPlay(section){

    const videos = section.querySelectorAll(
      '.lh_pet_video_carousel__autoplay_video'
    );

    if(!videos.length) return;


    if(isMobile()){

      // 第一个进入页面自动播放
      playVideo(videos[0]);

      const observer = new IntersectionObserver(entries=>{

        entries.forEach(entry=>{

          if(entry.isIntersecting && entry.intersectionRatio >= 0.9){
            playVideo(entry.target);
          }

        });

      },{
        threshold:[0.9]
      });


      videos.forEach(video=>{
        observer.observe(video);
      });


    }else{


      const observer = new IntersectionObserver(entries=>{

        entries.forEach(entry=>{

          if(entry.isIntersecting){
            playVideo(entry.target);
          }

        });

      },{
        threshold:0.6
      });


      videos.forEach(video=>{
        observer.observe(video);
      });

    }

  }


function initCarousel() {
  document.querySelectorAll(
    '.lh_pet_video_carousel'
  ).forEach(function (section) {
    var track = section.querySelector(
      '[data-lh-pet-video-carousel-track]'
    );

    var prev = section.querySelector(
      '.lh_pet_video_carousel__arrow_prev'
    );

    var next = section.querySelector(
      '.lh_pet_video_carousel__arrow_next'
    );

    if (!track) return;

    // 防止 Shopify section 重新加载后重复绑定
    if (section.dataset.lhPetVideoCarouselReady === 'true') return;
    section.dataset.lhPetVideoCarouselReady = 'true';

    function getScrollAmount() {
      var cards = track.querySelectorAll(
        '.lh_pet_video_carousel__card'
      );

      if (cards.length > 1) {
        var distance = Math.abs(
          cards[1].offsetLeft - cards[0].offsetLeft
        );

        if (distance > 0) {
          return distance;
        }
      }

      var card = cards[0];

      if (!card) {
        return Math.max(track.clientWidth * 0.8, 260);
      }

      var trackStyle = window.getComputedStyle(track);

      var gap =
        parseFloat(trackStyle.columnGap) ||
        parseFloat(trackStyle.gap) ||
        16;

      return card.getBoundingClientRect().width + gap;
    }

    function move(direction) {
      var amount = getScrollAmount();

      var maxScroll = Math.max(
        0,
        track.scrollWidth - track.clientWidth
      );

      var targetLeft = track.scrollLeft + direction * amount;

      targetLeft = Math.max(
        0,
        Math.min(targetLeft, maxScroll)
      );

      if (typeof track.scrollTo === 'function') {
        try {
          track.scrollTo({
            left: targetLeft,
            behavior: 'smooth'
          });
        } catch (error) {
          track.scrollLeft = targetLeft;
        }
      } else {
        track.scrollLeft = targetLeft;
      }

      window.setTimeout(function () {
        playVisibleVideo(track);
      }, 450);
    }

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        move(-1);
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        move(1);
      });
    }

    initAutoPlay(section);
  });
}

function playVisibleVideo(track){

  const videos = track.querySelectorAll('.lh_pet_video_carousel__autoplay_video');
  const trackRect = track.getBoundingClientRect();
  for(const video of videos){
    const rect = video
      .closest('.lh_pet_video_carousel__card')
      .getBoundingClientRect();
    if(
      rect.left >= trackRect.left &&
      rect.right <= trackRect.right
    ){
      playVideo(video);
      break;
    }
  }
}

function initVideoButtons(){
  document.querySelectorAll(
    '[data-lh-pet-video-play]'
  ).forEach(btn=>{
    btn.addEventListener('click',()=>{
      const card = btn.closest('.lh_pet_video_carousel__card');
      const video = card?.querySelector('.lh_pet_video_carousel__autoplay_video');
      if(video){
        playVideo(video);
      }
    });
  });
}

  function initModal(){
    const modal = document.querySelector(
      '[data-lh-pet-video-modal]'
    );
    if(!modal) return;
    const modalVideo = modal.querySelector(
      '[data-lh-pet-video-modal-video]'
    );
    document.querySelectorAll(
      '[data-lh-pet-video-play]'
    ).forEach(btn=>{

      btn.addEventListener('click',()=>{
        const url = btn.dataset.videoUrl;
        if(!url) return;
        modal.classList.add('is-active');
        modal.setAttribute(
          'aria-hidden',
          'false'
        );
        modalVideo.src = url;
        modalVideo.play();
      });
    });

    modal.querySelectorAll(
      '[data-lh-pet-video-close]'
    ).forEach(btn=>{
      btn.addEventListener('click',()=>{
        modal.classList.remove('is-active');
        modal.setAttribute(
          'aria-hidden',
          'true'
        );
        modalVideo.pause();
        modalVideo.src='';
        if(currentVideo){
          currentVideo.play().catch(()=>{});
        }
      });
    });
  }
  function init(){
    initCarousel();
    initVideoButtons();
    initModal();
  }
  if(document.readyState === 'loading'){
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  }else{
    init();
  }
  document.addEventListener(
    'shopify:section:load',
    init
  );
})();
//icon js codex
 (function () {
    'use strict';

    var ITEMS_PER_PAGE = 3;

    function initIconNav(section) {
      if (!section) return;

      if (section.dataset.lhPetIconNavReady === 'true') {
        return;
      }

      var track = section.querySelector(
        '[data-lh-pet-icon-nav-track]'
      );

      var pagination = section.querySelector(
        '[data-lh-pet-icon-nav-pagination]'
      );

      if (!track || !pagination) return;

      var items = Array.prototype.slice.call(
        track.querySelectorAll('.lh_pet_icon_nav__item')
      );

      if (!items.length) return;

      section.dataset.lhPetIconNavReady = 'true';

      var pageCount = Math.ceil(
        items.length / ITEMS_PER_PAGE
      );

      var currentPage = 0;
      var scrollFrame = null;

      function isMobileLayout() {
        return window.matchMedia(
          '(max-width: 989px)'
        ).matches;
      }

      function getPageOffsets() {
        if (!items.length) return [0];

        var firstOffset = items[0].offsetLeft;

        var maxScroll = Math.max(
          0,
          track.scrollWidth - track.clientWidth
        );

        var offsets = [];

        for (var page = 0; page < pageCount; page++) {
          /*
          * 最后一个分页点始终滚动到轨道最右端。
          * 最后一组不足三个时，前面的项目自然补齐画面。
          */
          if (page === pageCount - 1) {
            offsets.push(maxScroll);
            continue;
          }

          var targetIndex = page * ITEMS_PER_PAGE;
          var targetItem = items[targetIndex];

          if (!targetItem) continue;

          var targetOffset = Math.max(
            0,
            targetItem.offsetLeft - firstOffset
          );

          offsets.push(
            Math.min(targetOffset, maxScroll)
          );
        }

        return offsets.length ? offsets : [0];
      }

      function setActivePage(pageIndex) {
        pageIndex = Math.max(
          0,
          Math.min(pageIndex, pageCount - 1)
        );

        currentPage = pageIndex;

        pagination
          .querySelectorAll(
            '.lh_pet_icon_nav__pagination_dot'
          )
          .forEach(function (dot, index) {
            var isActive = index === pageIndex;

            dot.classList.toggle(
              'is-active',
              isActive
            );

            dot.setAttribute(
              'aria-current',
              isActive ? 'true' : 'false'
            );
          });
      }

      function getClosestPage() {
        var offsets = getPageOffsets();
        var scrollLeft = track.scrollLeft;

        var closestPage = 0;
        var closestDistance = Infinity;

        offsets.forEach(function (offset, index) {
          var distance = Math.abs(
            scrollLeft - offset
          );

          if (distance < closestDistance) {
            closestDistance = distance;
            closestPage = index;
          }
        });

        return closestPage;
      }

      function goToPage(pageIndex, behavior) {
        var offsets = getPageOffsets();

        pageIndex = Math.max(
          0,
          Math.min(pageIndex, offsets.length - 1)
        );

        var targetLeft = offsets[pageIndex] || 0;

        setActivePage(pageIndex);

        if (typeof track.scrollTo === 'function') {
          track.scrollTo({
            left: targetLeft,
            behavior: behavior || 'smooth'
          });
        } else {
          track.scrollLeft = targetLeft;
        }
      }

      function buildPagination() {
        pagination.innerHTML = '';

        if (pageCount <= 1) {
          pagination.hidden = true;
          return;
        }

        for (var page = 0; page < pageCount; page++) {
          var dot = document.createElement('button');

          dot.type = 'button';

          dot.className =
            'lh_pet_icon_nav__pagination_dot';

          dot.setAttribute(
            'aria-label',
            'Go to group ' + (page + 1)
          );

          dot.dataset.lhPetIconNavPage = String(page);

          if (page === 0) {
            dot.classList.add('is-active');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.setAttribute('aria-current', 'false');
          }

          pagination.appendChild(dot);
        }

        pagination.hidden = !isMobileLayout();
      }

      pagination.addEventListener(
        'click',
        function (event) {
          var dot = event.target.closest(
            '[data-lh-pet-icon-nav-page]'
          );

          if (!dot) return;

          event.preventDefault();

          var pageIndex = parseInt(
            dot.dataset.lhPetIconNavPage,
            10
          );

          if (isNaN(pageIndex)) return;

          goToPage(pageIndex, 'smooth');
        }
      );

      track.addEventListener(
        'scroll',
        function () {
          if (!isMobileLayout()) return;

          if (scrollFrame) {
            cancelAnimationFrame(scrollFrame);
          }

          scrollFrame = requestAnimationFrame(
            function () {
              setActivePage(
                getClosestPage()
              );
            }
          );
        },
        {
          passive: true
        }
      );

      function handleResize() {
        pagination.hidden =
          pageCount <= 1 || !isMobileLayout();

        if (!isMobileLayout()) {
          track.scrollLeft = 0;
          setActivePage(0);
          return;
        }

        requestAnimationFrame(function () {
          goToPage(currentPage, 'auto');
        });
      }

      buildPagination();

      if ('ResizeObserver' in window) {
        var resizeObserver = new ResizeObserver(
          handleResize
        );

        resizeObserver.observe(section);

        section._lhPetIconNavResizeObserver =
          resizeObserver;
      } else {
        window.addEventListener(
          'resize',
          handleResize
        );
      }

      handleResize();
    }

    function initAllIconNavs(root) {
      root = root || document;

      if (
        root.matches &&
        root.matches('[data-lh-pet-icon-nav]')
      ) {
        initIconNav(root);
      }

      if (!root.querySelectorAll) return;

      root
        .querySelectorAll('[data-lh-pet-icon-nav]')
        .forEach(initIconNav);
    }

    window.LH_INIT_PET_ICON_NAV =
      initAllIconNavs;

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          initAllIconNavs(document);
        },
        {
          once: true
        }
      );
    } else {
      initAllIconNavs(document);
    }

    if (!window.LH_PET_ICON_NAV_SECTION_BOUND) {
      window.LH_PET_ICON_NAV_SECTION_BOUND = true;

      document.addEventListener(
        'shopify:section:load',
        function (event) {
          initAllIconNavs(event.target);
        }
      );
    }
  })();